import React from 'react'

const ActiveJobs = () => {
  return (
    <div>ActiveJobs</div>
  )
}

export default ActiveJobs